import axios from 'axios';
import { getBaseUrl } from '../utils';


const client = axios.create({
    baseURL: getBaseUrl(),
    timeout: 10000
})
client.interceptors.response.use((response) => {
    return response;
}, error => {
    return Promise.reject(error.response);
});


export default client;


// WEBPACK FOOTER //
// ./src/js/services/http.js